export default __webpack_public_path__ + "static/media/Pahalgam2.11113eac.jpg";